import React, { useState } from "react";
import Sidebar from "../components/Sidebar/Sidebar";
import Header from "../components/Header/Header";
import FAQDashboard from "../pages/FAQDashboard";
import PolicyDashboard from "../pages/PolicyDashboard";
import { Box, Typography, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import CreateFaqDialog from "../components/CreateFaqDialog";
import UploadCsvDialog from "../components/UploadCsvDialog";
import PolicyHeader from "../components/PolicyHeader";

const menuItems = [
  "Search FAQs",
  "De-Enroll Learners",
  "Change Tracks",
  "Change Electives",
  "Approval Status",
];

interface ProgramOption {
  label: string;
  value: string;
}

const MainLayout: React.FC<{ children?: React.ReactNode }> = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const [uploadDialogOpen, setUploadDialogOpen] = useState(false);

  const handleCreateClick = () => {
    setCreateDialogOpen(true);
  };

  const handleCreateClose = () => {
    setCreateDialogOpen(false);
  };

  const handleCreateSave = (data: {
    faqs: { question: string; answer: string }[];
    globalVisibility: boolean;
    selectedPrograms: ProgramOption[];
  }) => {
    setCreateDialogOpen(false);
  };

  const handleUploadClick = () => {
    setUploadDialogOpen(true);
  };

  const handleUploadClose = () => {
    setUploadDialogOpen(false);
  };

  const handleUploadSave = (data: {
    faqs: { question: string; answer: string }[];
    globalVisibility: boolean;
    selectedPrograms: ProgramOption[];
    csvFile: File | null;
  }) => {
    // Handle the CSV upload here
    console.log("Upload data:", data);
    setUploadDialogOpen(false);
  };

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      }}
    >
      <Header />
      <Box
        sx={{
          display: "flex",
          flex: 1,
          overflow: "hidden",
          position: "relative",
        }}
      >
        <Sidebar activeIndex={activeIndex} setActiveIndex={setActiveIndex} />
        <Box
          sx={{
            flex: 1,
            py: 3,
            px: 4,
            bgcolor: "#fafafa",
            overflow: "auto",
            height: "calc(100vh - 64px)", // Subtract header height
          }}
        >
          {activeIndex === 1 ? (
            <PolicyHeader />
          ) : (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 3,
                bgcolor: "#fafafa",
                zIndex: 1,
                pt: 1,
              }}
            >
              <Typography
                variant="h4"
                sx={{ fontWeight: 700, fontSize: "16px", color: "#000" }}
              >
                Search FAQs
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                }}
              >
                <Button
                  variant="contained"
                  startIcon={<UploadFileIcon sx={{ width: 16, height: 16 }} />}
                  onClick={handleUploadClick}
                  sx={{
                    border: "1px solid #000",
                    bgcolor: "#fff",
                    color: "#000",
                    boxShadow: "none",
                    borderRadius: "6px",
                    px: 3,
                    py: 1,
                    fontSize: 12,
                    fontWeight: 600,
                    textTransform: "none",
                  }}
                >
                  Bulk Upload FAQ
                </Button>
                <Button
                  variant="contained"
                  startIcon={<AddIcon sx={{ width: 16, height: 16 }} />}
                  onClick={handleCreateClick}
                  sx={{
                    border: "1px solid #000",
                    bgcolor: "#fff",
                    color: "#000",
                    boxShadow: "none",
                    borderRadius: "6px",
                    px: 3,
                    py: 1,
                    fontSize: 12,
                    fontWeight: 600,
                    textTransform: "none",
                  }}
                >
                  Create FAQ
                </Button>
              </Box>
            </Box>
          )}
          {activeIndex === 0 ? (
            <FAQDashboard />
          ) : activeIndex === 1 ? (
            <PolicyDashboard />
          ) : (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="100%"
            >
              <Typography variant="h4" color="text.secondary">
                {menuItems[activeIndex]}
              </Typography>
            </Box>
          )}
          <CreateFaqDialog
            open={createDialogOpen}
            onClose={handleCreateClose}
            onSave={handleCreateSave}
          />
          <UploadCsvDialog
            open={uploadDialogOpen}
            onClose={handleUploadClose}
            onSave={handleUploadSave}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default MainLayout;
